//after edit code
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    Row, Col, Breadcrumb, BreadcrumbItem, Form, FormGroup, Input, Button, Label, Card
} from 'reactstrap';
import FilterForm from './FilterForm/index'
import 'react-datepicker/dist/react-datepicker.css';
import {
    checkDuplicateCounterParty, checkDuplicateZone,
    appliedPortfolioFilters, filterValueListRemove, deleteAppliedFilterList, SearchRequestBody, portfolioDataHandle, sortDataByKey, sortByDate, checkAllCheckboxMethod, setCounterpartyList, setInitialValues,
    pageLink, currentLink, paginatedRequestBody
} from './helper';
import './new-portfolio.scss';
import * as PortfolioConstants from './constants';
import {
    fetchPortfolioDetails,
    searchPortfolio,
    fetchRiskLevels,
    fetchProductNameFilterList,
    fetchRiskScoreTrendFilter,
    fetchCaseStatusFilter,
    fetchBusinessSegmentFilter,
    fetchLegalConstitutionFilter,
    fetchProductTypeDetails,
    searchPortfolioSuccess
} from './action';
import { viewSelectedCounterpartySuccess } from '../corporate/action';
import BuyForm from '../search-result/View/BuyForm/index'
import { getCounterpartyType, getZone } from '../../Analyst/Cases/Create/actions'
import PortfolioTable from './Table/index';
import { setFilters } from '../dashboard/action';
import { MODAL_TYPE_SUCCESS, MODAL_TYPE_FORM } from '../../constants';
import CorporateModal from '../../components/UI/CorporateModal';
import { ProductTypesPop } from '../productTypesPop';
import { Preloading } from '../../components/UI/Preloader/action';
import { toast } from 'react-toastify';

class NewPortfolio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            popoverOpen: false,
            modal: false,
            appliedFilters: [],
            appliedFiltersList: [],
            clearAllButton: null,
            clearFlag: false,
            toDate: null,
            fromDate: null,
            portfolioData: [],
            sortFlag: true,
            showModal: false,
            body: null,
            modalType: MODAL_TYPE_FORM,
            modalTitle: '',
            modalCloseHandler: () => { },
            checkedAll: false,
            initialValues: {},
            selectedPortfolioData: [],
            zoneList: [],
            currentPage: 0,
            sortType: PortfolioConstants.SORT_TYPE_DESCENDING,
            sortField: PortfolioConstants.DEFAULT_SORT_FIELD,
            searchText: ''
        };
    }
    componentDidMount() {
        // this.props.fetchPortfolioDetails();
        this.props.getZone();
        this.props.fetchCounterPartyType();
        this.props.fetchRiskLevels();
        this.props.fetchProductNameFilterList();
        this.props.fetchRiskScoreTrendFilter();
        this.props.fetchCaseStatusFilter();
        this.props.fetchBusinessSegmentFilter();
        this.props.fetchLegalConstitutionFilter();
        if (Object.keys(this.props.dashBoardFilters).length > 0) {
            this.dashBoardFiltersUpdate(this.props.dashBoardFilters, this.props.dashBoardFilters.toDate, this.props.dashBoardFilters.fromDate);
        } else {
            this.props.preloading(true);
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, PortfolioConstants.DEFAULT_REQUEST_BODY)
            this.props.searchPortfolio(requestBody);
            // this.props.fetchPortfolioDetails();
        }
    }
    dashBoardFiltersUpdate = (dashBoardFilters, toDate, fromDate) => {
        const appliedTempFilters = appliedPortfolioFilters(dashBoardFilters, toDate, fromDate);
        this.setState({
            appliedFilters: dashBoardFilters,
            appliedFiltersList: appliedTempFilters,
            toDate: toDate,
            fromDate: fromDate,
            initialValues: setInitialValues(dashBoardFilters),
            clearAllButton: <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
        })
        // this.props.setFilters(null);
        this.props.preloading(true);
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, dashBoardFilters)
        this.props.searchPortfolio(requestBody);
    }
    componentDidUpdate(prevProps) {
        const { portfolioListData, productTypeDetails, createCase, portfolioListFailure } = this.props
        if (this.props.zoneList !== prevProps.zoneList) {
            this.setState({
                zoneList: this.props.zoneList
            })
        }
        if (!createCase.error && createCase !== prevProps.createCase) {
            this.props.preloading(true);
            toast.success(
                <div>
                    <i className="fa fa-check text-large-150"></i>&nbsp;Case Successfully Created!
                </div>
            );
            this.props.fetchPortfolioDetails();

        }
        else if (createCase.error && createCase !== prevProps.createCase) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(createCase.error.response && createCase.error.response.data) ? createCase.error.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
        }
        if (portfolioListData !== prevProps.portfolioListData) {
            this.setPortfolioData();
        }
        if (portfolioListFailure !== prevProps.portfolioListFailure) {
            this.props.preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;{(portfolioListFailure.response && portfolioListFailure.response.data) ? portfolioListFailure.response.data.message : "Something went wrong! Please try again."}
                </div>
            );
            this.setState({
                portfolioData: []
            })

        }
        if (productTypeDetails !== prevProps.productTypeDetails) {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body:
                    <ProductTypesPop productTypes={productTypeDetails} />,
                modalType: MODAL_TYPE_SUCCESS,
                modalTitle: 'Details of various products subscribed',
                modalCloseHandler: this.toggleModal
            }))
        }
    }
    toggle = () => {
        this.setState(prevState => ({
            popoverOpen: !prevState.popoverOpen
        }));
    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }
    filterFormCallback = (filterFormData, toDate, fromDate) => {
        if (filterFormData) {
            const appliedTempFilters = appliedPortfolioFilters(filterFormData, toDate, fromDate);
            this.setState({
                appliedFilters: filterFormData,
                appliedFiltersList: appliedTempFilters,
                toDate: toDate,
                fromDate: fromDate,
                currentPage: 0
            })

            if (appliedTempFilters.length > 0) {
                this.setState({
                    clearAllButton: <Button className="filter-item filter-item-btn-clear" color="link" size="xs" onClick={this.handleClearAll}>Clear All</Button>
                })
            }
            this.props.preloading(true)
            const searchRequest = SearchRequestBody('', filterFormData, toDate, fromDate);
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
            this.toggle()
        } else {
            this.setState(prevState => ({
                initialValues: {},
                appliedFilters: [],
                appliedFiltersList: [],
                clearAllButton: null,
                toDate: null,
                fromDate: null
            }))
        }

    }
    handleClearAll = () => {
        this.setState(prevState => ({
            initialValues: {},
            appliedFilters: [],
            appliedFiltersList: [],
            clearAllButton: null,
            clearFlag: !prevState.clearFlag,
            toDate: null,
            fromDate: null
        }))
        this.props.preloading(true);
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, PortfolioConstants.DEFAULT_SORT_FIELD, PortfolioConstants.SORT_TYPE_DESCENDING, PortfolioConstants.DEFAULT_REQUEST_BODY)
        this.props.searchPortfolio(requestBody);
        // this.props.fetchPortfolioDetails();
    }
    handleRemoveFilter = (removeFilterListData) => {
        this.props.preloading(true)
        const removedFilterList = filterValueListRemove(removeFilterListData, this.state.appliedFiltersList)
        const aplliedFiltersDelete = deleteAppliedFilterList(removeFilterListData, this.state.appliedFilters)
        if (removedFilterList.length === 0) {
            this.handleClearAll();
        } else {
            let initialVal = {}, toDate = this.state.toDate, fromDate = this.state.fromDate;
            if (removeFilterListData.date) {
                this.setState({
                    toDate: null,
                    fromDate: null
                })
                toDate = null;
                fromDate = null;
            }
            removedFilterList.forEach((item, index, element) => {
                initialVal[item] = true
            })
            this.setState(prevState => ({
                appliedFiltersList: removedFilterList,
                appliedFilters: aplliedFiltersDelete,
                initialValues: {
                    ...initialVal
                }
            }))
            const searchRequest = SearchRequestBody('', aplliedFiltersDelete, toDate, fromDate)
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
        }
    }
    handleBulkBuy = () => {
        if (this.state.selectedPortfolioData.length > 0) {
            const tempcounterpartyList = setCounterpartyList(this.state.portfolioData);
            this.props.viewSelectedCounterpartySuccess(tempcounterpartyList)
            const checkDuplicateZoneFlag = checkDuplicateZone(this.state.selectedPortfolioData)
            let zonesSelected = [];
            if (checkDuplicateZoneFlag) {
                for (let i = 0; i < this.props.zoneList.length; i++) {
                    if (this.props.zoneList[i].name === this.state.selectedPortfolioData[0].zoneName) {
                        zonesSelected.push({ id: this.props.zoneList[i].id, name: this.props.zoneList[i].name })
                        break;
                    }
                }
            } else {
                this.props.zoneList.forEach((item, index, element) => {
                    this.state.selectedPortfolioData.forEach((selectedZone, i, selectedData) => {
                        if (item.name === selectedZone.zoneName) {
                            zonesSelected.push({ id: item.id, name: item.name })
                        }
                    })
                })
            }

            const checkDuplicateCounterPartyFlag = checkDuplicateCounterParty(this.state.selectedPortfolioData)

            if (checkDuplicateCounterPartyFlag) {
                this.setState(prevState => ({
                    showModal: !prevState.showModal,
                    body: <BuyForm toggle={this.toggleModal} selectedValueData={this.state.selectedPortfolioData} selectedvalue={this.state.selectedPortfolioData[0].counterpartyType} zoneSelected={zonesSelected} buyFormType={PortfolioConstants.PORTFOLIO_BUY} />,
                    modalType: MODAL_TYPE_FORM,
                    modalTitle: 'Bulk buy reports',
                    modalCloseHandler: this.toggleModal
                }))
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;Please select same type of counterparties to buy reports for!
                    </div>
                );
            }
        } else {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle text-large-150"></i>&nbsp;Please select same type of counterparties to buy reports for!
                </div>
            );
        }
    }
    handleBuyAction = (value) => {
        let zonesSelected = [];
        this.props.viewSelectedCounterpartySuccess(value)
        for (let i = 0; i < this.props.zoneList.length; i++) {
            if (this.props.zoneList[i].name === value.zoneName) {
                zonesSelected.push({ id: this.props.zoneList[i].id, name: this.props.zoneList[i].name })
                break;
            }
        }
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: <BuyForm toggle={this.toggleModal} selectedvalue={value.counterpartyType} zoneSelected={zonesSelected} buyFormType={PortfolioConstants.PORTFOLIO_BUY} />,
            modalType: MODAL_TYPE_FORM,
            modalTitle: 'Buy report for - ' + value.counterpartyName,
            modalCloseHandler: this.toggleModal
        }))
    }
    setPortfolioData = () => {
        let actionButton = null
        let tempPortfolioData = portfolioDataHandle(this.props.portfolioListData.portfolioRowViewList)
        this.props.portfolioListData.portfolioRowViewList.forEach((item, index, element) => {
            (item.status[0] === PortfolioConstants.CREATE) ?
                actionButton = <Button className="p-1" block outline color="primary" name={item.status} id={item.status} onClick={() => this.handleBuyAction(item)}>Buy</Button> :
                actionButton = item.status
            tempPortfolioData[index].status = actionButton
        })
        this.setState({
            portfolioData: tempPortfolioData
        });
        this.props.preloading(false)
    }
    handleSearchChange = (event) => {
        if (event.key === PortfolioConstants.ENTER) {
            this.props.preloading(true)
            event.preventDefault()
            const searchRequest = SearchRequestBody(event.target.value, this.state.appliedFilters, this.state.toDate, this.state.fromDate)
            const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
            this.props.searchPortfolio(requestBody);
            this.setState({
                searchText: event.target.value
            })
        }
    }

    sortByPortfolioDataKey = (key) => {
        let sortDirection;
        if (this.state.sortType === PortfolioConstants.SORT_TYPE_DESCENDING) {
            sortDirection = PortfolioConstants.SORT_TYPE_ASCENDING
        } else {
            sortDirection = PortfolioConstants.SORT_TYPE_DESCENDING
        }
        this.setState({
            sortField: key,
            sortType: sortDirection
        })
        this.props.preloading(true)
        const searchRequest = SearchRequestBody(this.state.searchText, this.state.appliedFilters, this.state.toDate, this.state.fromDate)
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, key, sortDirection, searchRequest)
        this.props.searchPortfolio(requestBody);

    }
    handleCheckChildElement = (event) => {
        let tempPortfolioData = [...this.state.portfolioData];
        let tempSelectedPortfolioData = [...this.state.selectedPortfolioData];
        let tempFlag = false;
        tempPortfolioData.forEach((value, index, element) => {
            if (event.target.checked === true) {
                if (value.id === event.target.value) {
                    value.isChecked = event.target.checked
                    tempSelectedPortfolioData.push(value);
                    this.setState({
                        selectedPortfolioData: tempSelectedPortfolioData
                    })
                }
            } else {
                if (value.id === event.target.value) {
                    value.isChecked = event.target.checked
                    tempSelectedPortfolioData.forEach((item, i, selectedData) => {
                        if (value.id === item.id) {
                            tempSelectedPortfolioData.splice(i, 1);
                        }
                    })
                    this.setState({
                        selectedPortfolioData: tempSelectedPortfolioData
                    })
                }
            }
        })

        const checkAllCheckbox = checkAllCheckboxMethod(tempPortfolioData)
        if (checkAllCheckbox) {
            tempFlag = true
        }
        this.setState({
            portfolioData: tempPortfolioData,
            checkedAll: tempFlag
        })
    }

    handleAllChecked = (event) => {
        let tempPortfolioData = [...this.state.portfolioData]
        tempPortfolioData.forEach(value => value.isChecked = event.target.checked)
        this.setState({ selectedPortfolioData: tempPortfolioData, checkedAll: event.target.checked })
    }
    productDescriptionModal = () => {
        this.props.fetchProductTypeDetails()
    }
    
    render() {
        return (
            <React.Fragment>

                <Col className="corporate-portfolio">
                    <Breadcrumb className="mb-3">
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>My Portfolio</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className="d-flex justify-content-between no-gutters mb-4 position-relative">
                        <Form className="form-search col-24 col-sm-8 mb-sm-0">
                            <FormGroup className="mb-0 input-search">
                                <i className="icon-search position-absolute"></i>
                                <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search within my portfolio" autoComplete="off" />
                            </FormGroup>
                        </Form>
                    </Row>
                    <div className="custom-table-wrapper p-sm-2">
                        <Row noGutters className="custom-table-header d-none d-sm-flex align-items-center">
                            <Col sm="24" className="px-2">
                                <Row noGutters className="align-items-center">
                                    <Col
                                        sm="5"
                                        className="custom-table-header-title px-2 py-3"
                                        onClick={() => this.sortByPortfolioDataKey('counterpartyName')}>
                                        Company Name <i className={(this.state.sortField === 'counterpartyName') ? "icon-updown" : ''}/>
                                    </Col>
                                    <Col
                                        sm="3"
                                        className="custom-table-header-title px-2 py-3 text-center"
                                        onClick={() => this.sortByPortfolioDataKey('counterpartyType')}>
                                        Counterparty  <i className={(this.state.sortField === 'counterpartyType') ? "icon-updown" : ''}/>
                                    </Col>
                                    <Col
                                        sm="4"
                                         className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer"
                                         onClick={() => this.sortByPortfolioDataKey('riskScore')}>
                                        Rubix Risk Score <i className={(this.state.sortField === 'riskScore') ? "icon-updown" : ''}/>
                                    </Col>
                                    <Col
                                        sm="4"
                                        className="custom-table-header-title px-2 py-3 text-sm-center cursor-pointer"
                                        title="Payment score"
                                        >
                                        Payment score<i className={(this.state.sortField === 'riskLevel') ? "icon-updown" : ''}/>
                                    </Col>
                                    <Col
                                        sm="4"
                                        className="custom-table-header-title px-2 py-3 cursor-pointer text-center">
                                        CUG payment score
                                    </Col>
                                    <Col
                                        sm="4"
                                        className="custom-table-header-title px-2 py-3 cursor-pointer text-center"
                                        onClick={() => this.sortByPortfolioDataKey('updatedAt')}>
                                        Updated On
                                        <i className={(this.state.sortField === 'updatedAt') ? "icon-updown" : ''}/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <PortfolioTable portfolioData={this.state.portfolioData} handleCheckChildElement={this.handleCheckChildElement} productTypeDescription={this.productDescriptionModal} history={this.props.history}/>
                    </div>
                </Col>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    counterPartyData: state.createCase.dropdownData,
    zoneList: state.createCase.zoneList,
    riskLevel: state.portfolio.riskLevelSuccess,
    reportType: state.portfolio.productNameListSuccess,
    legalConstitution: state.portfolio.legalConstitutionSuccess,
    businessSegment: state.portfolio.businessSegmentSuccess,
    riskTrend: state.portfolio.riskTrendSuccess,
    caseStatus: state.portfolio.caseStatusSuccess,

    // fetchPortfolioDetails()  call responses
    portfolioListData: state.portfolio.portfolioList,
    fetchPortfolioDetailsFailure: state.portfolio.portfolioListFailure, // failure for fetchPortfolioDetails() & searchPortfolio()

    searchPortfolioData: state.portfolio.searchPortfolioSuccess,

    productTypeDetails: state.portfolio.productTypeDetails,
    productTypeDetailsFailure: state.portfolio.productTypeDetailsFailure,

    createCase: state.createCase.result,
    dashBoardFilters: state.dashboard.portfolioFilters,
    portfolioListFailure: state.portfolio.portfolioListFailure
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchPortfolioDetails: () => { dispatch(fetchPortfolioDetails()) },
    fetchCounterPartyType: () => { dispatch(getCounterpartyType()) },
    getZone: () => { dispatch(getZone()) },
    searchPortfolio: (data) => { dispatch(searchPortfolio(data)) },
    searchPortfolioSuccess: (data) => { dispatch(searchPortfolioSuccess(data)) },
    fetchRiskLevels: () => { dispatch(fetchRiskLevels()) },
    fetchProductNameFilterList: () => { dispatch(fetchProductNameFilterList()) },
    fetchRiskScoreTrendFilter: () => { dispatch(fetchRiskScoreTrendFilter()) },
    fetchCaseStatusFilter: () => { dispatch(fetchCaseStatusFilter()) },
    fetchBusinessSegmentFilter: () => { dispatch(fetchBusinessSegmentFilter()) },
    fetchLegalConstitutionFilter: () => { dispatch(fetchLegalConstitutionFilter()) },
    viewSelectedCounterpartySuccess: (data) => { dispatch(viewSelectedCounterpartySuccess(data)) },
    fetchProductTypeDetails: () => { dispatch(fetchProductTypeDetails()) },
    setFilters: (data) => { dispatch(setFilters(data)) },
    preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); }
});
export default NewPortfolio = connect(
    mapStateToProps,
    mapDispatchToProps
)(NewPortfolio)
